<ui-page-container size="medium">
  <mat-card>
    <mat-card-title>
      <p class="card-inner-title">
        {{ (entityId ? 'Modifica documento archivistico' : 'Aggiungi documento archivistico') | translate }}
      </p>
      <div
        class="alert-role"
        *roleVisibility="['create', 'update']; classNames: ['DocumentoArc']; behaviour: 'show'">
        <p>
          {{ 'Il tuo ruolo ti permette solamente di visualizzare le informazioni relative al documento archivistico.' | translate }}
        </p>
        <p>
          {{ 'Nessuna azione di modifica avrà effetto.' | translate }}
        </p>
      </div>
    </mat-card-title>
    <mat-card-content class="source-container">
      <aside>
        <div class="source-general-actions source-arc-actions">
          <app-card-actions
            *ngIf="entityId"
            className="DocumentoArc"
            [entity]="entityForm?.value"
            [entityId]="entityId"
            (changeStatus)="changeStatusHandler($event)">
          </app-card-actions>
        </div>
      </aside>
      <mat-tab-group animationDuration="0ms">
        <mat-tab [label]="'Generali' | translate">
          <form
            class="source-arc-general"
            *ngIf="entityForm"
            [formGroup]="entityForm"
            (ngSubmit)="dispatchAction(entityForm)">
            <mat-form-field class="input-expanse">
              <mat-label>{{ 'Titolo' | translate }}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="titolo"
                [placeholder]="'Titolo' | translate">
            </mat-form-field>

            <mat-form-field class="input-expanse">
              <mat-label>{{ 'Descrizione' | translate }}</mat-label>
              <textarea
                class="input-expanse"
                type="text"
                matInput
                formControlName="descrizione"
                [placeholder]="'Descrizione' | translate">
              </textarea>
            </mat-form-field>

            <mat-form-field class="input-expanse">
              <mat-label>{{ 'Evento' | translate }}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="evento"
                [placeholder]="'Evento' | translate">
            </mat-form-field>
            <div class="horizontal-inputs-container">
              <mat-form-field class="input-expanse">
                <mat-label>{{ 'Mittente' | translate }}</mat-label>
                <input
                  class="input-expanse"
                  type="text"
                  matInput
                  formControlName="mittente"
                  [placeholder]="'Mittente' | translate">
              </mat-form-field>
              <mat-form-field class="input-expanse">
                <mat-label>{{ 'Destinatario' | translate }}</mat-label>
                <input
                  class="input-expanse"
                  type="text"
                  matInput
                  formControlName="destinatario"
                  [placeholder]="'Destinatario' | translate">
              </mat-form-field>
            </div>
            <mat-form-field class="input-expanse">
              <mat-label>{{ 'Tipo' | translate }}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="tipo"
                [placeholder]="'Tipo' | translate">
            </mat-form-field>

            <mat-form-field class="input-expanse">
              <mat-label>{{ 'Collocazione' | translate }}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="collocazione"
                [placeholder]="'Collocazione' | translate">
            </mat-form-field>
            <mat-form-field class="input-expanse">
              <mat-label>{{ 'Fondo' | translate }}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="fondo"
                [placeholder]="'Fondo' | translate">
            </mat-form-field>
            <mat-form-field class="input-expanse">
              <mat-label>{{ 'Serie' | translate }}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="serie"
                [placeholder]="'Serie' | translate">
            </mat-form-field>
            <mat-form-field class="input-expanse">
              <mat-label>{{Segnatura' | translate}}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="segnatura"
                [placeholder]="'Segnatura' | translate">
            </mat-form-field>
            <mat-form-field class="input-expanse">
              <mat-label>{{'Trascrizione' | translate}}</mat-label>
              <textarea
                class="input-expanse"
                type="text"
                matInput
                formControlName="trascrizione"
                [placeholder]="'Trascrizione' | translate">
              </textarea>
            </mat-form-field>
            <mat-form-field class="input-expanse">
              <mat-label>{{'Lingua' | translate}}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="lingua"
                [placeholder]="'Lingua' | translate">
            </mat-form-field>
            <div class="horizontal-inputs-container">
              <mat-form-field class="input-expanse">
                <mat-label>{{'Data Inizio' | translate}}</mat-label>
                <input
                  class="input-expanse"
                  matInput
                  formControlName="dataInizio"
                  [placeholder]="'Data Inizio' | translate">
              </mat-form-field>
              <mat-form-field class="input-expanse">
                <mat-label>{{'Data Fine' | translate}}</mat-label>
                <input
                  class="input-expanse"
                  matInput
                  formControlName="dataFine"
                  [placeholder]="'Data Fine' | translate">
              </mat-form-field>
            </div>
            <mat-form-field class="input-expanse">
              <mat-label>{{'Datazione' | translate}}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="datazione"
                [placeholder]="'Datazione' | translate">
            </mat-form-field>
            <h3>{{ 'Tag' | translate }}</h3>
            <ng-container *roleVisibility="['create', 'update']; classNames: ['DocumentoArc']">
              <p>
                {{ 'Inserisci uno o più tag.' | translate }}
              </p>
              <mat-form-field
                class="input-expanse"
                appearance="fill">
                <mat-label>{{ 'Tag' | translate }}</mat-label>
                <mat-chip-grid #chipList>
                  <mat-chip-row
                    *ngFor="let tag of entityForm?.get('tag').value; let i = index"
                    [removable]="true"
                    (removed)="removeTagHandler(entityForm?.get('tag'), i)">
                    {{ tag }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip-row>
                  <input
                    #inputTag
                    placeholder="Nuovo tag"
                    [matChipInputAddOnBlur]="true"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="addTagHandler(entityForm?.get('tag'), $event, inputTag)">
                </mat-chip-grid>
              </mat-form-field>
            </ng-container>

            <ng-container *roleVisibility="['create', 'update']; classNames: ['DocumentoArc']; behaviour: 'show'">
              <p *ngIf="(entityForm?.get('tag')?.controls || []).length > 0">{{ 'Tag presenti' | translate }}</p>
              <p
                *ngIf="(entityForm?.get('tag')?.controls || []).length === 0">{{ 'Nessun tag presente' | translate }}</p>
              <mat-chip-listbox>
                <mat-chip *ngFor="let t of entityForm?.get('tag')?.controls || []">{{ t.value }}</mat-chip>
              </mat-chip-listbox>
            </ng-container>

            <h3>{{ 'Immagine' | translate }}</h3>
            <app-media-form-view
              [mediaId]="entityForm.get('immagine')?.value"
              [excludedExtensions]="['pdf']"
              (update)="updateImageHandler($event)">
            </app-media-form-view>
            <h3>{{ 'File' | translate }}</h3>
            <app-media-form-view
              [mediaId]="entityForm.get('file')?.value"
              (update)="updateFileHandler($event)">
            </app-media-form-view>

            <div class="source-actions">
              <button
                *roleVisibility="['create', 'update']; classNames: ['DocumentoArc']"
                mat-raised-button
                color="primary"
                type="submit">
                {{ (entityId ? 'Salva' : 'Aggiungi') | translate }}
              </button>
            </div>

          </form>
        </mat-tab>
        <mat-tab
          [label]="'Beni correlati' | translate"
          *ngIf="mode === 'edit'">
          <app-arc-cards [sourceArc]="entityForm?.value"></app-arc-cards>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</ui-page-container>
